module.exports = __webpack_public_path__ + "assets/images/boundaries/details/4-members.svg?v=1d5753aa";